import React from 'react'

const Resolution = (probs) => {
    const { item } = probs
    const htmlString = item?.replace(/\n/g, '<br>');
    // const [ Text] = item.value.split('\n\n');
    // const pointers = Text.split('\n')
    // .map(key => key.replace(/^\d+\.\s*/, '')) // Remove the number at the start of each instruction
    // .filter(key => key.trim().length > 0); 
    return (
        <div>
            <div
                style={{ margin: "20px 10px", height: "24px" }}
                className="header-prob"
            >
                RESOLUTION
            </div>
            <div style={{ marginLeft: '20px', overflowWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: item }} className='system-check-para' />

        </div>
    )
}

export default Resolution
